import { createDomain, sample } from 'effector'
import { createGate } from 'effector-react'
import { MassMailing } from '~/shared/api/massMailing'
import { createCache } from '~/shared/lib/mapCacheFactory'
import { isString } from '~/shared/lib/utils'

export const domain = createDomain('entities.massMailing')

export const Gate = createGate<{ massMailingId: UniqueId }>()

export const $massMailingId = domain
  .createStore<UniqueId | null>(null)
  .on(Gate.state, (_, { massMailingId }) => massMailingId)
  .on(Gate.close, () => null)

export const requestFx = domain.createEffect<UniqueId, MassMailing>({
  handler: fetchMassMailing,
})

export const saveMassMailingFx = domain.createEffect<MassMailing, MassMailing>({
  async handler(massMailing) {
    await massMailing.save()
    return fetchMassMailing(massMailing.getApiId() as UniqueId)
  },
})

sample({
  clock: $massMailingId,
  filter: isString,
  target: requestFx,
})

const {
  $cache: $massMailingCache,
  useCache: useMassMailingCache,
  updateCache,
} = createCache<MassMailing>({
  domain,
  getEntityId: (massMailing) => massMailing.getApiId() as UniqueId,
})
export { $massMailingCache, useMassMailingCache }

$massMailingCache.on(
  [requestFx.doneData, saveMassMailingFx.doneData],
  (cache, massMailing) => updateCache(cache, [massMailing]),
)

export async function fetchMassMailing(id: UniqueId) {
  const response = await MassMailing.with('regions').find(id)
  return response.getData() as MassMailing
}
